export default __webpack_public_path__ + "static/media/BS05.a7631af7.jpg";